import dayjs from 'dayjs'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import { HeaderBar } from './Header'
import { Race } from '../../../races/api'
import { Typography } from '../../typography'
import classes from './RaceHeader.module.css'

export default function MatchHeader({ race }: { race: Race }) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  return (
    <div
      className={clsx(classes.raceHeaderContainer, {
        [classes.headerDesktop]: isDesktop,
      })}
    >
      {!isDesktop && <HeaderBar back={-1} />}

      <div className={classes.wrapper} data-mobile={!isDesktop}>
        <div className={classes.left}>
          <div className={classes.top_left} />
          <div className={classes.bottom_left} />
        </div>
        <div className={classes.titleWrapper}>
          <Typography
            fs="xxl"
            fw={700}
            fc={{ light: 'white', dark: 'white' }}
            level={1}
            lh="100"
            ta="center"
          >
            Race {race.round_number}
          </Typography>
          <Typography
            fs="sm"
            fc={{ light: 'white', dark: 'white' }}
            ta="center"
          >{`${dayjs(race.round_start).format('D MMM')} - ${dayjs(race.round_start).add(6, 'day').format('D MMM')}`}</Typography>
        </div>
        <div className={classes.right}>
          <div className={classes.top_right} />
          <div className={classes.bottom_right} />
        </div>
      </div>
    </div>
  )
}
